import React from 'react'
import Typed from 'react-typed'
import styled from 'styled-components'

const TypedTitle = () => {
  return (
    <StyledTyped
      loop
      strings={['Creator', 'Developer', 'Entrepreneur']}
      typeSpeed={60}
      backSpeed={70}
      backDelay={500}
    />
  )
}

const StyledTyped = styled(Typed)`
  font-family: VT323;
  font-style: monospace;
  font-size: 60px;
  color: #ff206e;

  @media (max-width: 910px) {
    font-size: 40px !important;
  }
`

export default TypedTitle
